export const getCommandForSurveySegment = (command) => {
  if (command.type === 'cusSurvey' && command.data.segment) {
    const newCommand = structuredClone(command);

    // TODO: Binary Search 이용한 성능 개선
    newCommand.data.positions = command.data.positions.filter(({ segment }) => {
      return segment === command.data.segment.index;
    });
    return newCommand;
  }

  return command;
};
